import React, { useState } from "react";

const AppContext = React.createContext();

export const AppProvider = ({ children }) => {
  // const [baseUrl] = useState("http://127.0.0.1:8000/api");
  // const [baseUrlforfile] = useState("http://127.0.0.1:8000/storage");
  const [authToken, setAuthToken] = useState("");
  const [selectedRideType, setSelectedRideType] = useState("");
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [selectedRideforFindingDriver, setSelectedRideforFindingDriver] = useState({});

  const [GOOGLE_API_KEY] = useState("AIzaSyCWhWJWmD1OwglKnA6vNsY1xXhKr_QbcW8");
  const [baseUrl] = useState("https://trustidrive.btsportfolio2026.com/backend/public/api");
  const [baseUrlforfile] = useState("https://trustidrive.btsportfolio2026.com/backend/public/storage");

  const [selectedUserTypeForApp, setSelectedUserTypeForApp] = useState("");
  //////////////validation//////////////
  const usernameRegex = new RegExp(/^(?=.{6,}$)[A-Za-z0-9]+(?: [A-Za-z0-9]+)*$/);
  const emailRegExp = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);
  const passwordRegExp = new RegExp(/^[A-Za-z0-9@.$?&_\-#!]{8,}$/);
  const phonenumberRegExp = new RegExp(/^[0-9]{4}-[0-9]{7}$/);
  const formatPhoneNumber = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 11);
    if (digits.length > 4) {
      return `${digits.slice(0, 4)}-${digits.slice(4)}`;
    }
    return digits;
  };
  const RegExpChecker = (type, inp) => {
    switch (type) {
      case "username":
        if (!usernameRegex.test(inp)) {
          return "Username must be atleast 6 characters and contain only letter and numbers";
        }
        break;
      case "email":
        if (!emailRegExp.test(inp)) {
          return "Enter a valid email!(e.g. example@gmail.com)";
        }
        break;
      case "password":
        if (!passwordRegExp.test(inp)) {
          return "Password must be at least 8 characters and include letters, numbers and special characters";
        }
        break;
      case "phonenumber":
        if (!phonenumberRegExp.test(inp)) {
          return "Enter a valid phone number (e.g. 0300-9988998)";
        }
        break;
      default:
        return "";
    }

    return "";
  };
  return (
    <AppContext.Provider
      value={{
        baseUrl,
        baseUrlforfile,
        selectedUserTypeForApp,
        authToken,
        selectedRideType,
        selectedOffer,
        selectedRideforFindingDriver,
        GOOGLE_API_KEY,
        setSelectedRideType,
        setSelectedOffer,
        setSelectedUserTypeForApp,
        RegExpChecker,
        formatPhoneNumber,
        setAuthToken,
        setSelectedRideforFindingDriver,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;
